const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://203.175.74.144:12000";
const trimmedBaseUrl = rawBaseUrl.endsWith("/") ? rawBaseUrl.slice(0, -1) : rawBaseUrl;

export const API_BASE_URL = trimmedBaseUrl.endsWith("/api") ? trimmedBaseUrl : `${trimmedBaseUrl}/api`;
